<div class="modal-header">
  <h4 class="modal-title pull-left">{{ 'popups.modalTitles.' + headerTitle | translate}}</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form method="post" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate> <!--  -->
    <div class="row">
      @for (row of formObject; track row; let i = $index) {
        <div class="col-12 col-sm-6">
          <div class="form-group">
            <label>
              {{'popups.addTenantModal.filedLabels.' + row.fieldLabel | translate}}
              @if (row.validationRequired) {
                <span class="requiredStar">*</span>
              }
            </label>
            <input [type]="row.type" class="form-control" [formControlName]="row.field"
              placeholder="{{'popups.addTenantModal.filedLabels.' + row.fieldLabel | translate}}"
              [required]="row.validationRequired ? 'required' : ''">
              @if (form  && form.get(row.field)?.invalid && (form.get(row.field)?.dirty || form.get(row.field)?.touched)) {
                <div
                  class="alert alert-danger">
                  @if (form && form.get(row.field)?.errors?.['required']) {
                    <div>
                      {{'popups.requiredField' | translate}}
                    </div>
                  }
                  @if (form && form.get(row.field)?.errors?.['pattern']) {
                    <div>
                      {{'popups.numberFieldPattern' | translate}}
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
      <div class="text-center mt-2">
        <button type="submit" class="btn btn-primary"
          [disabled]="!form.valid">
          {{'login.submit' | translate}}
        </button>
      </div>
    </form>
  </div>
